import React, { useEffect, useState } from 'react'
import { ClientService } from '../../component/services/client.service';
import toast from 'react-hot-toast';
import { Card, Col, Image, Row, Table, Form, OverlayTrigger, Tooltip, Badge, Spinner } from 'react-bootstrap';
import TablePaginationComponent from '../../component/table/TablePagination';
import { resolveModuleName } from 'typescript';
import { FaFileImage, FaFilePdf, FaRegEye } from 'react-icons/fa';
import PreviewModal from '../../component/modals/Preview.modal';
import moment from 'moment';
import Select from "react-select"
import { StringHelper } from '../../component/helpers/String.helper';
import { Label } from 'recharts';
import DownloadCsv from '../../component/DownloadCsv';
import BypassPreviewModal from '../../component/modals/BypassPreview.modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import FiltersComponent, { FilterOption } from '../../component/Filters/FiltersComponent';
import StatsCard from '../../component/Cards/StatsCard';

export default function BypassDetails() {

    const [shifts, setShifts] = useState<any>();
    const [selectValue, setSelectValue] = useState<any>();
    const [pageSize, setPageSize] = useState<number>(10);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalCount, setTotolCount] = useState<number>(0);
    const [examName, setExamName] = useState<string>("");
    const [showPreviewModal, setShowPreviewModal] = useState<any>(undefined)
    const [bypassData, setBypassData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false)
    const [showBypassPreviewModal, setShowBypassPreviewModal] = useState<any>(undefined);
    const [data, setData] = useState<any>();


    const [selectedFilters, setSelectedFilters] = useState<{
        states: FilterOption[];
        zones: FilterOption[];
        districts: FilterOption[];
        centers: FilterOption[];
        courses?: FilterOption[];
        verification?: FilterOption[];
    }>({
        states: [],
        zones: [],
        districts: [],
        centers: [],
        verification: [],
        courses: [],
    });

    const handleFiltersChange = (filters: any) => {
        setSelectedFilters(filters);
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setExamName(res.data.name);
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id,
                        startTime: data.startTime,
                        endTime: data.endTime
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }


    const getAllBypassData = async () => {
        if (!selectValue) {
            toast.error("Please select a shift");
            return;
        }
        let payload = {};
        if (selectedFilters?.centers?.length > 0) {
            payload = { ...payload, center: selectedFilters?.centers?.map((center: any) => center.value) }
        }
        if (selectedFilters?.states?.length > 0) {
            payload = { ...payload, state: selectedFilters?.states?.map((state: any) => state.value) }
        }
        if (selectedFilters?.districts?.length > 0) {
            payload = { ...payload, city: selectedFilters?.districts?.map((district: any) => district.value) }
        }
        if (selectedFilters?.zones?.length > 0) {
            payload = { ...payload, zone: selectedFilters?.zones?.map((zone: any) => zone.value) }
        }
        if (selectedFilters?.verification && selectedFilters?.verification?.length > 0) {
            payload = { ...payload, verificationMethods: selectedFilters?.verification?.map((zone: any) => zone.value) }
        }
        if (selectedFilters?.courses && selectedFilters?.courses?.length > 0) {
            payload = { ...payload, courseName: selectedFilters?.courses?.map((zone: any) => zone.value) }
        }

        setLoading(true)
        await ClientService.getAllBypassData(selectValue, pageSize, pageNumber, payload)
            .then((res) => {
                if (res.status === 200) {
                    setBypassData(res.data.bypassVerifications);
                    setTotolCount(res.data.totalBypassVerifications);
                    setData({
                        totalBypass: res.data.totalBypassVerifications,
                        totalDistinct: res.data.totalDistinctByPassVerifications


                    })
                }
            })
            .catch((err) => {
                toast.error(err.response?.data || "An error occurred");
            });
        setLoading(false)
    };

    async function createCsv(): Promise<any[]> {
        let selectedShift = shifts?.find((shift: any) => shift?.value === selectValue);

        const d = bypassData.map((data: any, index: number) => ({
            "Sr. No": index + 1,
            "Exam": examName,
            "Shift": selectedShift?.label,
            "Date": moment(selectedShift?.startTime).format("DD-MM-YYYY"),
            "Name": data?.studentId?.name || "N/A",
            "Roll No": data?.studentId?.rollNo || "N/A",
            "Course": data?.courseName || "N/A",
            "State": data?.studentId?.state || "N/A",
            "Division": data?.studentId?.zone || "N/A",
            "District": data?.studentId?.city || "N/A",
            "Venue ID": data?.studentId?.centerPreference || "N/A",
            "Venue Name": data?.studentId?.allocatedCenterId || "N/A",
            "Bypass Method": data?.verificationDetails
                ?.filter((detail: any) => detail?.manuallyVerified === true)
                .map((verification: any) =>
                    verification?.method === "fingerprint"
                        ? "Right Fingerprint"
                        : verification?.method === "fingerprint2"
                            ? "Left Fingerprint"
                            : verification?.method || "N/A"
                )
                .join(" - "),
            "B. Sub-type": data?.verificationDetails
                ?.filter((detail: any) => detail?.bypassSubType)
                .map((detail: any) => detail?.bypassSubType)
                .join(" - "),
            "B. Reason": data?.verificationDetails
                ?.filter((detail: any) => detail?.bypassReason)
                .map((detail: any) => detail?.bypassReason)
                .join(" - "),
            "Bypass On": moment(data?.verificationDetails[0]?.success_time).format("DD/MM/YYYY, HH:MM A")
        })) || [];
        return d;
    }

    useEffect(() => {
        getAllShift();
    }, []);

    useEffect(() => {
        if (selectValue) {
            setBypassData([])
            getAllBypassData();
        }
    }, [pageNumber, pageSize, selectedFilters]);

    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={8}>
                    <h4 className="text-secondary mt-3 fw-bold">Bypass Candidates</h4>
                </Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectValue(e?.value)}
                        isClearable
                        value={selectValue ? shifts.find((shift: any) => shift.value === selectValue.value) : null}
                    />
                </Col>
            </Row>

            <FiltersComponent
                selectedShift={selectValue}
                onFiltersChange={handleFiltersChange}
                showExamFilters={true}
                showVerificationFilters={true}
                isVenueRecquired={true}
            />

            {loading &&
                <div className="d-flex justify-content-center align-items-center my-3">
                    <Spinner animation="border" />
                </div>
            }

            {
                bypassData?.length > 0 &&
                <DownloadCsv
                    headers={["Sr. No", "Exam", "Shift", "Date", "Name", "Roll No", "State", "Division", "District", "Venue ID", "Venue Name", "Bypass Method", "B. Sub-type", "B. Reason", "Bypass On"]}
                    createCsv={createCsv}
                    fileName='bypass_data'
                />
            }
            <Row>
                <Col>
                    <Card
                        className="mt-3"
                        style={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "12px",
                            border: "none",
                        }}
                    >
                        <Card.Body>
                            <div className="d-flex align-items-center  justify-content-end ">
                                <FontAwesomeIcon icon={faRefresh} className='m-2 cursor-pointer' onClick={getAllBypassData} />
                            </div>
                            <Row className="d-flex ">
                                <Col md={3} className="mb-3">
                                    <StatsCard
                                        title="Total Bypass Verification"
                                        value={data?.totalBypass || 0}
                                        icon={faUserCircle}
                                        iconColor="primary"
                                        valueColor="primary"
                                    />
                                </Col>
                                <Col md={3} className="mb-3">
                                    <StatsCard
                                        title="Total Distinct Bypass"
                                        value={data?.totalDistinct || 0}
                                        icon={faUserCircle}
                                        iconColor="primary"
                                        valueColor="primary"
                                    />
                                </Col>
                            </Row>
                            <Table striped hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: 14 }}>Sr. No</th>
                                        <th style={{ fontSize: 14 }}>Name</th>
                                        <th style={{ fontSize: 14 }}>Roll No</th>
                                        <th style={{ fontSize: 14 }}>Exam</th>
                                        <th style={{ fontSize: 14 }}>State</th>
                                        <th style={{ fontSize: 14 }}>Division</th>
                                        <th style={{ fontSize: 14 }}>District</th>
                                        <th style={{ fontSize: 14 }}>Venue ID</th>
                                        <th style={{ fontSize: 14 }}>Venue Name</th>
                                        <th style={{ fontSize: 14 }}>Verification Method</th>
                                        <th style={{ fontSize: 14 }}>B. Sub-type</th>
                                        <th style={{ fontSize: 14 }}>B. Reason</th>
                                        <th style={{ fontSize: 14 }}>B. Image</th>
                                        <th style={{ fontSize: 14 }}>Live Photo</th>
                                        <th style={{ fontSize: 14 }}>Bypass On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bypassData && bypassData.length > 0 ? (
                                        bypassData.map((data: any, index: number) => {
                                            const bypass = data?.verificationDetails?.filter((detail: any) => detail?.manuallyVerified);
                                            let time = null;
                                            for(let i = 0; i < data?.verificationDetails?.length; i++) {
                                                if(data?.verificationDetails[i]?.success_time) {
                                                    time = moment(data?.verificationDetails[i]?.success_time).format("DD-MM-YYYY HH:mm:ss");
                                                    break;
                                                }
                                            }
                                            
                                            if(time == null){
                                                for(let i = 0; i < data?.verificationDetails?.length; i++) {
                                                    if(data?.verificationDetails[i]?.start_time) {
                                                        time = moment(data?.verificationDetails[i]?.start_time).format("DD-MM-YYYY HH:mm:ss");
                                                        break;
                                                    }
                                                }
                                            }
                                            return (
                                                <tr key={data._id || index}>
                                                    <td style={{ fontSize: 13 }}>{index + 1}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.name || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.rollNo || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.courseName || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.state || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.zone || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.city || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.centerPreference || "N/A"}</td>
                                                    <td style={{ fontSize: 13 }}>{data?.studentId?.allocatedCenterId || "N/A"}</td>
                                                    {/* <td style={{ fontSize: 13 }}>{data?.verificationDetails && data?.verificationDetails?.map((data: any) => {
                                                        return (
                                                            <Badge>{data?.bypassType === "fingerprint" ? "Right Fingerprint" : data?.bypassType === "fingerprint2" ? "Left Fingerprint" : data?.bypassType}</Badge>
                                                        )
                                                    }) || "--"}</td> */}
                                                    <td style={{ fontSize: 13 }}>
                                                        {data?.verificationDetails && data?.verificationDetails.map((detail: any) => (
                                                            <Badge className='me-2' bg={!detail?.manuallyVerified ? "success" : "danger"} >{detail?.method === "fingerprint" ? "Right Fingerprint" : detail?.method === "fingerprint2" ? "Left Fingerprint" : detail?.method}</Badge>
                                                        ))}
                                                    </td>
                                                    <td style={{ fontSize: 13 }}>
                                                        {bypass && bypass.length > 0
                                                            ? bypass.map((data: any) => data?.bypassSubType).join(", ")
                                                            : "--"}
                                                    </td>

                                                    {/* <td style={{ fontSize: 13, position: "relative" }}>
                                                        <span>
                                                            {bypassReason
                                                                ? StringHelper.truncate(bypassReason, 15)
                                                                : "--"}
                                                        </span>
                                                        {bypassReason &&
                                                            bypassReason.length > 15 && (
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={
                                                                        <Tooltip id="button-tooltip">
                                                                            <span>{bypassReason || "--"}</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span style={{ marginLeft: "8px", cursor: "pointer" }}>
                                                                        <FaRegEye />
                                                                    </span>
                                                                </OverlayTrigger>
                                                            )}
                                                    </td> */}

                                                    <td style={{ fontSize: 13, position: "relative" }}>
                                                        {bypass && bypass.length > 0 ? (
                                                            bypass.map((data: any, index: number) => (
                                                                <span key={index} style={{ display: "inline-flex", alignItems: "center" }}>
                                                                    {StringHelper.truncate(data?.bypassReason, 15)}
                                                                    {data?.bypassReason?.length > 15 && (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            delay={{ show: 250, hide: 400 }}
                                                                            overlay={
                                                                                <Tooltip id={`tooltip-${index}`}>
                                                                                    <span>{data.bypassReason}</span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <span style={{ marginLeft: 8, cursor: "pointer" }}>
                                                                                <FaRegEye />
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                    {index < bypass.length - 1 && ", "}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            "--"
                                                        )}
                                                    </td>

                                                    <td className="" style={{ fontSize: 13 }}>
                                                        <FaRegEye onClick={() => setShowBypassPreviewModal(bypass)} />
                                                    </td>


                                                    {/* <td className="" style={{ fontSize: 13 }}>
                                                        <div className="d-flex align-items-center gap-3">
                                                            {bypass && bypass.length > 0 ? (
                                                                bypass.map((data: any, index: number) => (
                                                                    <div key={index} className="d-flex flex-column align-items-center" style={{ width: 50 }}>
                                                                        {data?.bypassImage ? (
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                <Image
                                                                                    src={data.bypassImage}
                                                                                    width="70%"
                                                                                    height="70%"
                                                                                    style={{ cursor: "pointer", marginBottom: 5 }}
                                                                                    onClick={() => setShowPreviewModal(data.bypassImage)}
                                                                                />
                                                                                <span className="text-capitalize" style={{ fontSize: 10 }}>{data?.method === "fingerprint" ? "Right Fin..." : data?.method === "fingerprint2" ? "Left Fin..." : data?.method}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <span style={{ fontSize: 10 }}>No Image</span>
                                                                        )}
                                                                        {data?.bypassImage2 ? (
                                                                                                                                                       <div className="d-flex flex-column align-items-center">
                                                                                <Image
                                                                                    src={data.bypassImage2}
                                                                                    width="70%"
                                                                                    height="70%"
                                                                                    style={{  cursor: "pointer", marginBottom: 5 }}
                                                                                    onClick={() => setShowPreviewModal(data.bypassImage2)}
                                                                                />
                                                                                <span className="text-capitalize" style={{ fontSize: 10 }}>{data?.method === "fingerprint" ? "Right Fin..." : data?.method === "fingerprint2" ? "Left Fin..." : data?.method}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <span style={{ fontSize: 10 }}>No Image</span>
                                                                        )}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <span>No Image</span>
                                                            )}
                                                        </div>
                                                    </td> */}


                                                    <td style={{ fontSize: 13 }}>
                                                        {data?.userLivePhoto && data?.userLivePhoto ? (
                                                            <div style={{ width: 50, height: 50 }}>
                                                                <Image
                                                                    src={data?.userLivePhoto}
                                                                    width="100%"
                                                                    height="100%"
                                                                    style={{ borderRadius: '50%' }}
                                                                    onClick={() => setShowPreviewModal(data?.userLivePhoto)}

                                                                />
                                                            </div>
                                                        ) : (
                                                            <span>No Image</span>
                                                        )}
                                                    </td>
                                                    <td style={{ fontSize: 13 }}>
                                                        {
                                                            time || "--"
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={15} className="text-center">No data available</td>
                                        </tr>
                                    )}
                                </tbody>

                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <TablePaginationComponent
                        currentPage={pageNumber}
                        itemsCount={totalCount}
                        itemsPerPage={pageSize}
                        setItemsPerPage={(e: any) => setPageSize(e)}
                        setCurrentPage={setPageNumber}
                    />
                </Col>
            </Row>


            <PreviewModal
                show={showPreviewModal}
                handleClose={() => setShowPreviewModal(undefined)}

            />

            <BypassPreviewModal
                show={showBypassPreviewModal}
                handleClose={() => setShowBypassPreviewModal(undefined)}

            />
        </>
    )
}
